module.exports = __webpack_public_path__ + "img/unishark_pineapple_pomegranate.405be61a.png";